import { render } from "./SecurityChangeEmail.vue?vue&type=template&id=5ba081a8&ts=true"
import script from "./SecurityChangeEmail.vue?vue&type=script&lang=ts"
export * from "./SecurityChangeEmail.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__